export default __webpack_public_path__ + "static/media/laptopIcon.b5c45f89.png";